import React from 'react';
import Slider from 'react-slick';
import { Fade } from 'react-awesome-reveal';

import {
  SCREEN_MOBILE,
  SCREEN_TABLET,
  SCREEN_NORMAL,
  SCREEN_WIDE,
  SCREEN_HUGE,
} from '../../../config/constants';

import {
  CoreLink,
  Button,
  PictureBackground,
} from '../../../components';

import useWindowDimensions from '../../../helpers/useWindowDimensions';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import './style.scss';

const ParagraphSlider = ({ entity }) => {
  const { width } = useWindowDimensions();
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  /**
   * @example
   * @param props
   */
  function NextArrow(props) {
    const { onClick } = props;
    return (
      <div
        className="ParagraphSlider__next icon-before icon-after icon-arrow-right icon-variant-4 moving-arrow"
        onClick={onClick}
      />
    );
  }

  /**
   * @example
   * @param props
   */
  function PrevArrow(props) {
    const { onClick } = props;
    return (
      <div
        className="ParagraphSlider__prev icon-before icon-after icon-arrow-left icon-variant-4 moving-arrow"
        onClick={onClick}
      />
    );
  }

  // TODO REFACTOR THIS
  const centerPadding = () => {
    // 0 & 768
    if (width >= SCREEN_MOBILE && width <= SCREEN_TABLET) {
      return '10%';
    }

    // 768 & 992
    else if (width >= SCREEN_TABLET && width <= SCREEN_NORMAL) {
      return '8%';
    }

    // 992 & 1240
    else if (width >= SCREEN_NORMAL && width <= SCREEN_WIDE) {
      return '15%';
    }

    // 1240 & 2000
    else if (width >= SCREEN_WIDE && width <= SCREEN_HUGE) {
      return '25%';
    }

    // SCREEN_HUGE and larger
    return '25%';

  };

  const settings = {
    infinite: true,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: centerPadding(),
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 7000,
    pauseOnFocus: true,
    accessibility: true,
    touchMove: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <Fade triggerOnce bottom distance="50px" duration={500} className="Paragraph">
      <div id={paragraphKey} className="ParagraphSlider moving-arrow--proxy">
        <Slider {...settings}>
          {entity.getIn(['field_paragraphs']).map((item, key) => {
            return (
              <div key={item.get('target_uuid')} className="ParagraphSlider__item">
                <div className="ParagraphSlider__item__title">{item.getIn(['entity', 'field_title', 0, 'value'])}</div>
                <div className="ParagraphSlider__item__button">
                  <Button primary withIcon buttonIcon href={item.getIn(['entity', 'field_link', 0, 'uri'])}>{item.getIn(['entity', 'field_link', 0, 'title'])}</Button>
                </div>
                <PictureBackground
                  className="ParagraphSlider__item__image"
                  src={item.getIn(['entity', 'field_media', 0, 'styles', 'slider'])}
                  includeWebP
                />
                <CoreLink className="overlapping-link" to={item.getIn(['entity', 'field_link', 0, 'alias'], item.getIn(['entity', 'field_link', 0, 'uri']))}>{item.getIn(['entity', 'field_title', 0, 'value'])}</CoreLink>
              </div>
            );
          })}
        </Slider>
      </div>
    </Fade>
  );
};

export default ParagraphSlider;
